import React from 'react';

// Predefined icon set for service categories.
// Each `name` is the exact `iconName` string persisted on the backend (camelCase).
// Icons are inline SVGs (no external icon library needed).

const paths = {
  // default / generic
  category: (
    <>
      <rect x="3" y="3" width="7" height="7" rx="1.5" />
      <rect x="14" y="3" width="7" height="7" rx="1.5" />
      <rect x="3" y="14" width="7" height="7" rx="1.5" />
      <rect x="14" y="14" width="7" height="7" rx="1.5" />
    </>
  ),
  // remont / general repair tools
  wrench: (
    <path d="M14.7 6.3a4 4 0 0 0-5.4 5.2L3 17.8 6.2 21l6.3-6.3a4 4 0 0 0 5.2-5.4l-2.5 2.5-2.3-2.3 2.5-2.5z" />
  ),
  hammer: (
    <>
      <path d="M14 4l6 6-2 2-6-6z" />
      <path d="M12 6l-8 8 2.5 2.5 8-8" />
    </>
  ),
  screwdriver: (
    <>
      <path d="M14 4l6 6-3 3-6-6z" />
      <path d="M11 7L4 14l3 3 7-7" />
    </>
  ),
  drill: (
    <>
      <rect x="3" y="8" width="9" height="6" rx="1.5" />
      <path d="M12 9h4l4-2v10l-4-2h-4" />
      <path d="M6 14v5" />
    </>
  ),
  saw: (
    <>
      <path d="M3 8h14l4 4-4 4H3z" />
      <path d="M6 8v3M9 8v3M12 8v3M15 8v3" />
    </>
  ),
  ruler: (
    <>
      <rect x="2" y="7" width="20" height="10" rx="1.5" transform="rotate(-0 12 12)" />
      <path d="M6 7v3M10 7v4M14 7v3M18 7v4" />
    </>
  ),
  // tozalash / cleaning
  broom: (
    <>
      <path d="M15 4l-7 7" />
      <path d="M8 11l5 5-4 4H4l-1-1 5-8z" />
    </>
  ),
  brush: (
    <>
      <rect x="13" y="3" width="8" height="6" rx="1.5" transform="rotate(45 17 6)" />
      <path d="M11 9l-5 5c-1 1-1 4-3 5 2 1 5 0 6-2l4-5" />
    </>
  ),
  paint: (
    <>
      <path d="M5 3h11v6H5z" />
      <path d="M16 6h3v4h-6v3" />
      <rect x="11" y="13" width="4" height="8" rx="1" />
    </>
  ),
  // elektrik
  flash: <path d="M13 2L4 14h6l-1 8 9-12h-6z" />,
  plug: (
    <>
      <path d="M9 2v6M15 2v6" />
      <path d="M6 8h12v3a6 6 0 0 1-12 0z" />
      <path d="M12 17v5" />
    </>
  ),
  bulb: (
    <>
      <path d="M9 18h6" />
      <path d="M10 21h4" />
      <path d="M12 2a7 7 0 0 0-4 12.7V17h8v-2.3A7 7 0 0 0 12 2z" />
    </>
  ),
  // konditsioner / climate
  snow: (
    <>
      <path d="M12 2v20M2 12h20" />
      <path d="M5 5l14 14M19 5L5 19" />
    </>
  ),
  ac: (
    <>
      <rect x="2" y="4" width="20" height="9" rx="2" />
      <path d="M6 9h12" />
      <path d="M7 17c0 1.5-1 2-1 3M12 17c0 1.5-1 2-1 3M17 17c0 1.5-1 2-1 3" />
    </>
  ),
  // santexnik / plumbing
  water: <path d="M12 3s6 7 6 11a6 6 0 0 1-12 0c0-4 6-11 6-11z" />,
  faucet: (
    <>
      <path d="M3 9h6v3H3z" />
      <path d="M9 10h5a3 3 0 0 1 3 3v1" />
      <path d="M17 16v4M15 20h4" />
    </>
  ),
  // qurilish / building
  home: (
    <>
      <path d="M3 11l9-8 9 8" />
      <path d="M5 10v10h14V10" />
    </>
  ),
  truck: (
    <>
      <rect x="1" y="6" width="13" height="9" rx="1" />
      <path d="M14 9h4l3 3v3h-7z" />
      <circle cx="6" cy="18" r="2" />
      <circle cx="17" cy="18" r="2" />
    </>
  ),
  gear: (
    <>
      <circle cx="12" cy="12" r="3" />
      <path d="M12 2v3M12 19v3M4.2 4.2l2.1 2.1M17.7 17.7l2.1 2.1M2 12h3M19 12h3M4.2 19.8l2.1-2.1M17.7 6.3l2.1-2.1" />
    </>
  ),
};

// Ordered list of options shown in the picker grid. `category` is the default.
export const ICON_OPTIONS = [
  { name: 'category', label: 'Umumiy' },
  { name: 'wrench', label: 'Remont' },
  { name: 'broom', label: 'Tozalash' },
  { name: 'flash', label: 'Elektrik' },
  { name: 'plug', label: 'Rozetka' },
  { name: 'bulb', label: 'Yoritish' },
  { name: 'snow', label: 'Sovutish' },
  { name: 'ac', label: 'Konditsioner' },
  { name: 'water', label: 'Suv' },
  { name: 'faucet', label: 'Santexnik' },
  { name: 'paint', label: "Bo'yoq" },
  { name: 'brush', label: 'Moʼyqalam' },
  { name: 'hammer', label: 'Bolgʻa' },
  { name: 'screwdriver', label: 'Otvyortka' },
  { name: 'drill', label: 'Drel' },
  { name: 'saw', label: 'Arra' },
  { name: 'ruler', label: "O'lchagich" },
  { name: 'home', label: 'Qurilish' },
  { name: 'truck', label: "Ko'chirish" },
  { name: 'gear', label: 'Servis' },
];

export const DEFAULT_ICON = 'category';

// Renders the SVG for a given iconName. Falls back to the default icon if the
// name is unknown or missing, so the UI never breaks on empty/unexpected data.
export function CategoryIcon({ name, size = 24, color = 'currentColor', strokeWidth = 1.8, style }) {
  const inner = paths[name] || paths[DEFAULT_ICON];
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={style}
      aria-hidden="true"
    >
      {inner}
    </svg>
  );
}
